export type WorkflowTelemetryEvent =
  | { type: 'workflow_start'; workflowCode: string; userId?: string; tenantId?: string }
  | { type: 'workflow_step_advance'; workflowCode: string; fromStep: number; toStep: number }
  | { type: 'workflow_step_back'; workflowCode: string; fromStep: number; toStep: number }
  | { type: 'workflow_complete'; workflowCode: string; totalSteps: number }
  | { type: 'workflow_cancel'; workflowCode: string; atStep: number }
  | { type: 'workflow_skip_to_manual'; workflowCode: string; atStep: number }
  | { type: 'workflow_error'; workflowCode: string; error: string };

export type TelemetrySink = (event: WorkflowTelemetryEvent) => void;

export const defaultSink: TelemetrySink = (event) => {
  if (typeof window !== 'undefined') {
    console.debug('[kontora-telemetry]', event.type, event);
  }
  const customSink =
    typeof window !== 'undefined'
      ? (window as unknown as { __KONTORA_TELEMETRY__?: TelemetrySink }).__KONTORA_TELEMETRY__
      : undefined;
  if (customSink) {
    customSink(event);
  }
};

let sink: TelemetrySink = defaultSink;
let enabled = true;

export function configureTelemetry(options: { sink?: TelemetrySink; enabled?: boolean }): void {
  if (options.sink) sink = options.sink;
  if (typeof options.enabled === 'boolean') enabled = options.enabled;
}

export function emitTelemetry(event: WorkflowTelemetryEvent): void {
  if (!enabled) return;
  try {
    sink(event);
  } catch (err) {
    console.error('[kontora-telemetry] Sink-Fehler:', err);
  }
}

export function isTelemetryEnabled(): boolean {
  return enabled;
}

export function resetTelemetry(): void {
  sink = defaultSink;
  enabled = true;
}
